import { isString } from './isString.js';

function isNonEmptyString(value) {
    return isString(value) && value.length > 0;
}

export { isNonEmptyString };
